import {
    NavController,
    NavParams,
    App,
    ModalController,
    ViewController,
    ToastController,
  } from "ionic-angular";
  import { Storage } from "@ionic/storage";
  import { Component, OnInit, Input } from "@angular/core";
  
  import { AuthProvider } from "../../../../../providers/auth/auth";
  import { EmployeeRhProvider } from "../../../../../providers/employeerh/employeerh";
import { GoalRhProvider } from "../../../../../providers/goals/goals";
  
  @Component({
    selector: "page-rh-goals-create",
    templateUrl: "goals-create-list.html",
  })
  export class RhGoalsCreateList implements OnInit {
    list:any = {
      name: null,
      goals: []
    }
    existingLists:any = null;
    isBrowsingModels:boolean = false;
  
    constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public storageProvider: Storage,
      public app: App,
      public authProvider: AuthProvider,
      public employeeRhProvider: EmployeeRhProvider,
      public viewCtrl: ViewController,
      public toastCtrl: ToastController,
      private goalRhProvider: GoalRhProvider
    ) {}
  
    ngOnInit() {
      this.loadDatas();
    }
  
    loadDatas() {
      this.goalRhProvider.getGoalsList().subscribe((res) => {
        if(res.success){
          this.existingLists = res.data;
        }
      })
    }

    addGoal(){
      this.list.goals.push({
        title: null,
        period: null,
        percent_value: null
      })
    }

    removeGoal(index){
      this.list.goals.splice(index, 1)
    }

    createListWithGoals(){
      let totalPercentValue = 0;
      for(const goal of this.list.goals){
        totalPercentValue += +goal.percent_value
      }
      if(totalPercentValue !== 100){
        let toast = this.toastCtrl.create({ message: "Le total de pondération doit être égale à 100 et non " + totalPercentValue, duration: 6000, position: 'top'});
        toast.present();
        return;
      }
      this.goalRhProvider.createGoalListWithGoals(this.list.name, this.list.goals).subscribe((res) => {
        if(res.success){
          let toast = this.toastCtrl.create({ message: "Vous avez créé la liste : " + this.list.name, duration: 6000, position: 'top'});
          toast.present();
          this.dismiss();
        }
      })
    }

    loadModel(list){
      this.list.name = list.title;
      this.list.goals = list.goals;
      this.isBrowsingModels = false;
    }
  
    // Modal ctrl
    dismiss() {
      this.viewCtrl.dismiss();
    }
  }
  


// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-goals/goals-create-list/goals-create-list.ts